import { Button } from "@/components/ui/button";
import { Lock, LockOpen } from "lucide-react";
import { usePortfolioSizeLock } from "../../../hooks/usePortfolioSizeLock";

interface PortfolioSizeLockToggleProps {
  portfolioId: string;
}

export const PortfolioSizeLockToggle = ({ portfolioId }: PortfolioSizeLockToggleProps) => {
  const { isPortfolioSizeLocked, togglePortfolioSizeLock } = usePortfolioSizeLock(portfolioId);

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={togglePortfolioSizeLock}
      className="flex items-center gap-2 h-8 px-3 text-muted-foreground hover:text-foreground"
      title={isPortfolioSizeLocked ? "Portfolio size is locked - click to allow auto-growth" : "Portfolio size is unlocked - click to lock at current size"}
    >
      {isPortfolioSizeLocked ? (
        <>
          <Lock className="h-4 w-4" />
          <span className="text-xs">Locked</span>
        </>
      ) : (
        <>
          <LockOpen className="h-4 w-4" />
          <span className="text-xs">Unlocked</span>
        </>
      )}
    </Button>
  );
};